<template>
    <div style="height:70px; display:flex;width:100%; padding:5px 0px; padding-bottom:10px; border-top:1px solid #e9e9e9;box-shadow: 0px 4px 6px 0px #210F03;">
        <div style="flex:1; display:flex; flex-direction: column; justify-content: center;" @click="goPage('/view/home')">
            <div style="display:grid; place-items: center; height:40px;">
                <img :src="require('@/assets/img/navi_home_' + (path_name === '/view/home' ? 'on' : 'off') + '.png')" style="height:26px;">
            </div>
            <div style="text-align:center; font-size:14px; font-weight:500;" :style="{color: path_name === '/view/home' ? 'var(--color-main)' : '#B5B5B6'}">홈</div>
        </div>
        <div style="flex:1; display:flex; flex-direction: column; justify-content: center;" @click="goPage('/view/reservation')">
            <div style="display:grid; place-items: center; height:40px;">
                <img :src="require('@/assets/img/navi_reservation_' + (path_name === '/view/reservation' ? 'on' : 'off') + '.png')" style="height:26px;">
            </div>
            <div style="text-align:center; font-size:14px; font-weight:500;" :style="{color: path_name === '/view/reservation' ? 'var(--color-main)' : '#B5B5B6'}">근무예약</div>
        </div>
        <div style="flex:1; display:flex; flex-direction: column; justify-content: center;" @click="goPage('/view/attendance')">
            <div style="display:grid; place-items: center; height:40px;">
                <img :src="require('@/assets/img/navi_attendance_' + (path_name === '/view/attendance' ? 'on' : 'off') + '.png')" style="height:26px;">
            </div>
            <div style="text-align:center; font-size:14px; font-weight:500;" :style="{color: path_name === '/view/attendance' ? 'var(--color-main)' : '#B5B5B6'}">출퇴근</div>
        </div>
        <div style="flex:1; display:flex; flex-direction: column; justify-content: center;" @click="goPage('/view/my_page')">
            <div style="display:grid; place-items: center; height:40px;">
                <img :src="require('@/assets/img/my_page_' + (path_name === '/view/my_page' ? 'on' : 'off') + '.png')" style="height:26px;">
            </div>
            <div style="text-align:center; font-size:14px; font-weight:500;" :style="{color: path_name === '/view/my_page' ? 'var(--color-main)' : '#B5B5B6'}">마이페이지</div>
        </div>
        <div style="flex:1; display:flex; flex-direction: column; justify-content: center;" @click="goPage('/view/setting')">
            <div style="display:grid; place-items: center; height:40px;">
                <img :src="require('@/assets/img/navi_setting_' + (path_name === '/view/setting' ? 'on' : 'off') + '.png')" style="height:26px;">
            </div>
            <div style="text-align:center; font-size:14px; font-weight:500;" :style="{color: path_name === '/view/setting' ? 'var(--color-main)' : '#B5B5B6'}">설정</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageBottom",
        data(){
            return {
                path_name : '',
            }
        },
        methods : {
            goPage(page){
                if(this.$GlobalStore.isLogin()){
                    this.$router.push({ path: page + '?time=' + new Date().getTime()});
                } else {
                    if(page === '/view/reservation'
                        || page === '/view/attendance'
                        || page === '/view/setting'
                        || page === '/view/my_page'
                    ){
                        this.$GlobalStore.showConfirm('로그인 후 이용가능합니다.', async () => {}, '확인', '', async () => {})
                    }
                }

                // this.pathName = page;
            }
        },
        created(){
            this.path_name = location.pathname;
        }
    }
</script>

<style scoped>

</style>